"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require(".");
function makeFullUrl(baseUrl, resourceUrl) {
    if (!baseUrl) {
        return resourceUrl;
    }
    if (!resourceUrl) {
        return baseUrl;
    }
    if (baseUrl === resourceUrl) {
        return baseUrl;
    }
    if (baseUrl.endsWith('/') && resourceUrl.startsWith('/')) {
        return baseUrl + resourceUrl.substring(1);
    }
    if (!baseUrl.endsWith('/') && !resourceUrl.startsWith('/')) {
        return baseUrl + "/" + resourceUrl;
    }
    return baseUrl + resourceUrl;
}
exports.makeFullUrl = makeFullUrl;
function makeHeaderString(headers) {
    return Object.keys(headers).reduce(function (headerString, headerName) {
        return "" + headerString + headerName + ": " + headers[headerName] + "\n";
    }, '');
}
exports.makeHeaderString = makeHeaderString;
function createRequestPayload(requests) {
    var template = "--" + _1.BOUNDARY + "\n";
    requests.forEach(function (request) {
        template += "request-id: " + request.requestId + "\n\n\n\n";
        var url = makeFullUrl(request.baseURL, request.url);
        var method = request.method.toUpperCase();
        template += method + " " + url + "\n";
        template += makeHeaderString(request.headers);
        if (request.data) {
            template += "\n\n\n";
            if (typeof request.data === 'object') {
                template += JSON.stringify(request.data) + "\n";
            }
            else {
                template += request.data + "\n";
            }
        }
        template += "--" + _1.BOUNDARY + "\n";
    });
    return template.substring(0, template.length - 1) + "--";
}
exports.createRequestPayload = createRequestPayload;
